<template>
  <div class="sidebar-wrapper">
    <!-- Brand 区: 与 Navbar 同高 (50px), 不随菜单滚动 -->
    <router-link to="/home" class="sidebar-brand" :title="!isCollapse ? '' : '星书派 · 管理后台'">
      <span class="sidebar-brand__logo" aria-hidden="true">
        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="sb-logo-bg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#60a5fa"/>
              <stop offset="100%" stop-color="#2563eb"/>
            </linearGradient>
          </defs>
          <rect width="32" height="32" rx="8" ry="8" fill="url(#sb-logo-bg)"/>
          <!-- 五角星 (居中, 略偏上) -->
          <path d="M 16 7 L 18.3 12.7 L 24.5 13.3 L 19.7 17.2 L 21.2 23.2 L 16 19.8 L 10.8 23.2 L 12.3 17.2 L 7.5 13.3 L 13.7 12.7 Z"
                fill="#ffffff"/>
        </svg>
      </span>
      <span v-show="!isCollapse" class="sidebar-brand__text">
        <span class="sidebar-brand__title">星书派</span>
        <span class="sidebar-brand__subtitle">管理后台</span>
      </span>
    </router-link>

    <!-- 菜单 (滚动区) -->
    <scroll-bar class="sidebar-scroll">
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        :collapse="isCollapse"
        background-color="#0f172a"
        text-color="#cbd5e1"
        active-text-color="#60a5fa"
      >
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
    </scroll-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.sidebar-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #0f172a;
}

.sidebar-brand {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: var(--nav-height, 50px);
  padding: 0 14px;
  gap: 10px;
  background: #0b1220;
  border-bottom: 1px solid rgba(148, 163, 184, 0.08);
  color: #e2e8f0;
  text-decoration: none;
  transition: background 0.18s ease;
  overflow: hidden;
  white-space: nowrap;

  &:hover {
    background: #0f172a;
  }
}

.sidebar-brand__logo {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.sidebar-brand__text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  line-height: 1.1;
}

.sidebar-brand__title {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #f8fafc;
}

.sidebar-brand__subtitle {
  font-size: 11px;
  color: #b8c2d4;
  letter-spacing: 0.5px;
  margin-top: 1px;
}

.sidebar-scroll {
  flex: 1;
  min-height: 0;
}
</style>

<!-- 折叠态 (sidebar 36px 宽) brand 缩成纯 logo, 居中显示 -->
<style lang="scss">
.hideSidebar .sidebar-brand {
  padding: 0;
  justify-content: center;
}

.hideSidebar .sidebar-brand__logo {
  width: 22px;
  height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue